import { render, staticRenderFns } from "./TeamPositionHistory.vue?vue&type=template&id=0992f4ba&scoped=true&"
import script from "./TeamPositionHistory.vue?vue&type=script&lang=js&"
export * from "./TeamPositionHistory.vue?vue&type=script&lang=js&"
import style0 from "./TeamPositionHistory.vue?vue&type=style&index=0&id=0992f4ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0992f4ba",
  null
  
)

export default component.exports